import React from 'react';
import { useQuery } from '@tanstack/react-query';
import { Typography, CardContent, Grid2 as Grid, Skeleton } from '@mui/material';
import { ICandidateGroup, IHighlight } from './types';
import { StyledCard, styles } from './styles';
import Api from '../AgenticScreening/API';
import HighlightIcon from './HighlightIcon';

export default function Highlights({ group }: { group: ICandidateGroup }) {
  const { data: highlights, isLoading } = useQuery({
    queryKey: ['candidate_group_highlights', group.id],
    queryFn: async () => {
      const searchId = /candidate_sourcing\/searches\/(\d+)/.exec(window.location.href)?.[1];
      const response = await Api.getCandidateGroupHighlights(Number(searchId), group.id);
      return response.res.highlights;
    }
  });

  return (
    <StyledCard>
      <CardContent>
        <Typography variant="h6" gutterBottom sx={{ ...styles.sectionTitle, mb: 2 }}>
          Highlights
        </Typography>
        <Grid container spacing={2} sx={styles.sectionContent}>
          {highlights &&
            highlights.map((highlight: IHighlight, index: number) => (
              <Grid key={index} size={{ xs: 12, sm: 4 }} sx={styles.highlightCard}>
                <HighlightIcon highlight={highlight} />
                <Typography variant="body2" sx={{ fontWeight: 500 }}>
                  {highlight.value}
                </Typography>
              </Grid>
            ))}
          {isLoading && <Skeleton variant="text" width="100%" height="100%" />}
        </Grid>
      </CardContent>
    </StyledCard>
  );
}
